import React from "react";
import "./StatusTag.scss";
import { Tag } from "antd";
import { getColorBasedOnStatus } from "../../../utils/utils";
import { useTranslation } from "react-i18next";

const StatusTag = ({status = false}) => {
  const {t} = useTranslation();
  return (
    <Tag
      bordered={false}
      style={{
        ...getColorBasedOnStatus(status),
        textTransform: "capitalize",
      }}
    >
      {status === true ? t("CommonUtils.active") : t("CommonUtils.inactive")}
    </Tag>
  );
};

export default StatusTag;
